import { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import PMNDPSidebar from "../../pmndp/components/PMNDP-sidebar";
import { useLanguage } from "../../../utils/languageContext";
import "./Sidebar.css";
import HomeWorkIcon from '@mui/icons-material/HomeWork';
const getMenuItems = (t, uwinLoggedIn, isHealthFacilityManager, isDeliveryPointManager, isAsha, isJananiLoggedIn, eopdLoggedIn) => isHealthFacilityManager
	? [
		{
			name: t("sidebar.UIPsites"),
			link: "uip-vaccination-center",
			icon: <HomeWorkIcon className="menu-icon" />,
			hoverIcon: <HomeWorkIcon className="menu-icon" />,
		},
	]
	:
	isDeliveryPointManager
		? [
			{
				name: t("sidebar.dashboard"),
				link: "Dashboard",
				icon: "/images/Dashboard.svg",
				hoverIcon: "/images/Icon1.svg",
			},
			{
				name: t("sidebar.settings"),
				link: "setting",
				icon: "/images/Setting.jpg",
				hoverIcon: "/images/setting.svg",
			},
		]
		:
		isAsha ?
			[
				{
					name: t("sidebar.dashboard"),
					link: "Dashboard",
					icon: "/images/Dashboard.svg",
					hoverIcon: "/images/Icon1.svg",
				},
				...(uwinLoggedIn
					? [
						{
							name: t("sidebar.Duelist"),
							link: "DueList",
							icon: "/images/Sync.png",
							hoverIcon: "/images/Group.svg",
						},
					]
					: []),
				{
					name: t("sidebar.settings"),
					link: "setting",
					icon: "/images/Setting.jpg",
					hoverIcon: "/images/setting.svg",
				},
			] :
			[
				{
					name: t("sidebar.dashboard"),
					link: "Dashboard",
					icon: "/images/Dashboard.svg",
					hoverIcon: "/images/Icon1.svg",
				},
				...(eopdLoggedIn
					? [
						{
							name: t("sidebar.e-OPD"),
							link: "e-opd/beneficiary",
							icon: "/images/e-opd-grey.svg",
							hoverIcon: "/images/e-opd-white.svg",
						}
					]
					: []),
				// {
				// 	name: t("sidebar.todayTask"),
				// 	link: "Underdevloped",
				// 	icon: "/images/Task.png",
				// 	hoverIcon: "/images/todaystask.svg",
				// },

				...(uwinLoggedIn
					? [
						{
							name: t("sidebar.Session"),
							link: "Session",
							icon: "/images/Sync.png",
							hoverIcon: "/images/Group.svg",
						}
					]
					: []),
				...(isJananiLoggedIn
					? [
						{
							name: t("sidebar.jananiBeneficiary"),
							link: "janani-beneficiaries",
							icon: "/images/task.png",
							hoverIcon: "/images/todaystask.svg",
						}
					]
					: []),

				// {
				// 	name: t("sidebar.syncData"),
				// 	link: "Underdevloped",
				// 	icon: "/images/Sync.png",
				// 	hoverIcon: "/images/Group.svg",
				// },
				{
					name: t("sidebar.settings"),
					link: "setting",
					icon: "/images/Setting.jpg",
					hoverIcon: "/images/setting.svg",
				},
			];

const Sidebar = () => {
	const { t } = useLanguage();
	const navigate = useNavigate();

	const [hoverIndex, setHoverIndex] = useState(null);
	const [user, setUser] = useState(null);
	const [isSidebarVisible, setIsSidebarVisible] = useState(false);

	const uwinLoggedIn = Boolean(
		localStorage.getItem("uwin_loggedinUserdetails")
	);
	const pmndpToken = Boolean(localStorage.getItem("PMNDP_token"));

	const isHealthFacilityManager =
		JSON.parse(localStorage.getItem("loggedinUserdetails"))?.rolename === "Health Facility Manager";

	const isDeliveryPointManager =
		JSON.parse(localStorage.getItem("loggedinUserdetails"))?.rolename === "Delivery Point Manager";
	const isAsha =
		JSON.parse(localStorage.getItem("loggedinUserdetails"))?.rolename === "ASHA";
	const isJananiLoggedIn = Boolean(localStorage.getItem("JANANI_token"));

	const eopdLoggedIn = Boolean(localStorage.getItem("e-OPD_token"));

	const menuItems = useMemo(
		() => getMenuItems(t, uwinLoggedIn, isHealthFacilityManager, isDeliveryPointManager, isAsha, isJananiLoggedIn, eopdLoggedIn),
		[t, uwinLoggedIn, isHealthFacilityManager, isDeliveryPointManager, isAsha, isJananiLoggedIn, eopdLoggedIn]
	);

	useEffect(() => {
		const programKeyMap = {
			1: "NCD_loggedinUserdetails",
			2: "SICKLE_loggedinUserdetails",
			4: "NIKSHAY_loggedinUserdetails",
			5: "JANANI_loggedinUserdetails",
			6: "uwin_loggedinUserdetails",
			8: "PMNDP_loggedinUserdetails",
			11: "RBSK_loggedinUserdetails",
			12: "e-OPD_loggedinUserdetails"
		};

		const getUserFromStorage = () => {
			const programId = localStorage.getItem("currentLoggedInProgramId");
			let key = programKeyMap[programId];

			let data = key ? localStorage.getItem(key) : null;

			// 🔥 Fallback when unmapped
			if (!data) {
				for (let [id, k] of Object.entries(programKeyMap)) {
					const fallbackData = localStorage.getItem(k);

					if (fallbackData) {
						data = fallbackData;

						// ✅ update active program
						localStorage.setItem("currentLoggedInProgramId", id);

						break;
					}
				}
			}

			if (data) {
				try {
					setUser(JSON.parse(data));
				} catch (e) {
					console.error("User parse error", e);
					setUser(null);
				}
			} else {
				setUser(null);
			}
		};

		// ✅ Initial load
		getUserFromStorage();

		// ✅ Cross-tab
		const handleStorageChange = (e) => {
			if (
				e.key === "currentLoggedInProgramId" ||
				e.key?.includes("_loggedinUserdetails")
			) {
				getUserFromStorage();
			}
		};

		// ✅ Same tab (IMPORTANT FIX)
		const handleCustomEvent = () => {
			getUserFromStorage();
		};

		window.addEventListener("storage", handleStorageChange);
		window.addEventListener("userDetailsUpdated", handleCustomEvent);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
			window.removeEventListener("userDetailsUpdated", handleCustomEvent);
		};
	}, []);


	const toggleMobileSidebar = () => {
		setIsSidebarVisible((prev) => !prev);
	};
	//  =========================For mobile Back page not working Js ////////////////
	useEffect(() => {
		if (isSidebarVisible) {
			document.body.style.overflow = "hidden"; // scroll band
		} else {
			document.body.style.overflow = "auto"; // normal
		}

		return () => {
			document.body.style.overflow = "auto"; // cleanup
		};
	}, [isSidebarVisible]);
	return (
		<>
			{/* ================= MOBILE ================= */}
			<div className="mobile-only">
				<div className="top-bar">
					<button className="hamburger-button" onClick={toggleMobileSidebar}>
						☰
					</button>
				</div>
				{isSidebarVisible && (
					<div
						className="mobile-overlay"
						onClick={() => setIsSidebarVisible(false)}
					/>
				)}
				<div className={`mobile-sidebar ${isSidebarVisible ? "visible" : ""}`}>
					<button className="close-button" onClick={toggleMobileSidebar}>
						<span className="close-icon-sidebar">✕</span>
					</button>

					<SidebarMenu
						items={menuItems}
						hoverIndex={hoverIndex}
						onEnter={setHoverIndex}
						onLeave={() => setHoverIndex(null)}
						onItemClick={() => setIsSidebarVisible(false)}
					/>

					{pmndpToken ? (
						<PMNDPSidebar setIsSidebarVisible={setIsSidebarVisible} />
					) : (
						!isHealthFacilityManager &&
						(<div className="footer-btn">
							<button
								className="add-button"
								onClick={() => {
									navigate("/withoutabha")
									setIsSidebarVisible(false);
								}}

							>
								<img src="/images/Search.svg" alt="" />
								<span>{t("sidebar.searchBeneficiary")}</span>
							</button>
						</div>)
					)}
				</div>
			</div>

			{/* ================= DESKTOP ================= */}
			<div className="desktop-only">
				<div className="desktop-sidebar">
					<div className="header-sidebar">
						<img
							src="/images/Profile.png"
							alt="Profile"
							className="profile-image"
						/>
						<div className="userProfileDet">
							<h3>{user?.firstname || user?.name || user?.username}</h3>
							<p>{user?.cadrename || user?.rolename}</p>
							<p>{user?.facilitydetail || user?.facilityName}</p>
						</div>
					</div>

					<SidebarMenu
						items={menuItems}
						hoverIndex={hoverIndex}
						onEnter={setHoverIndex}
						onLeave={() => setHoverIndex(null)}
					/>

					{pmndpToken ? (
						<PMNDPSidebar setIsSidebarVisible={setIsSidebarVisible} />
					) : (
						!isHealthFacilityManager &&
						(<div className="footer-btn">
							<button
								className="add-button"
								onClick={() => navigate("/withoutabha")}
							>
								<img src="/images/Search.svg" alt="" />
								<span>{t("sidebar.searchBeneficiary")}</span>
							</button>
						</div>)
					)}
				</div>
			</div>
		</>
	);
};
const SidebarMenu = ({ items, hoverIndex, onEnter, onLeave, onItemClick }) => (
	<div className="menu">
		{items.map((item, index) => (
			<Link
				to={`/${item.link}`}
				className="menu-link"
				key={index}
				onClick={onItemClick}
			>
				<div
					className={`menu-item ${hoverIndex === index ? "hover" : ""}`}
					onMouseEnter={() => onEnter(index)}
					onMouseLeave={onLeave}
				>
					{typeof item.icon === "string"
						? <img src={hoverIndex === index ? item.hoverIcon : item.icon} alt={item.name} className="menu-icon" />
						: (hoverIndex === index ? item.hoverIcon : item.icon)
					}
					<span>{item.name}</span>
				</div>
			</Link>
		))}
	</div>
);

export default Sidebar;
